(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@finnairoyj/fcom-booking-widget", [], factory);
	else if(typeof exports === 'object')
		exports["@finnairoyj/fcom-booking-widget"] = factory();
	else
		root["@finnairoyj/fcom-booking-widget"] = factory();
})((() => {
      if (typeof self !== 'undefined') {
        return self;
      } else if (typeof globalThis !== 'undefined') {
        return globalThis;
      } else if (typeof window !== 'undefined') {
        return window;
      } else if (typeof global !== 'undefined') {
        return global;
      } else {
        return Function('return this')();
      }
    })(), () => {
return 